import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, TemplateRef, Input } from '@angular/core';
import { ResourceTypes } from '@klickdata/core/resource';
import { ResourceDetailsBaseComponent } from '../resource-details-base/resource-details-base.component';
import { EventJoin, StartEventService } from '@klickdata/core/resource/src/start-event.service';
import { Utils } from '@klickdata/core/util';
import { shareReplay } from 'rxjs/operators';
import { Resource } from '@klickdata/core/resource/src/resource.model';
import { Observable } from 'rxjs';
import { MessageSavedComponent, MessageService } from '@klickdata/core/message';
import { User } from '@klickdata/core/user';
@Component({
    selector: 'app-resource-details-events',
    templateUrl: './resource-details-events.component.html',
    styleUrls: ['./resource-details-events.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceDetailsEventsComponent extends ResourceDetailsBaseComponent implements OnInit {
    @Input() actionBtnTemplate: TemplateRef<any>;
    public mainEventType: { title: string; icon: string; color: string };
    public subEventType: { title: string; icon: string; color: string };
    constructor(
        private cd: ChangeDetectorRef,
        protected startEventService: StartEventService,
        protected message: MessageService
    ) {
        super();
    }
    ngOnInit(): void {
        this.mainEventType = this.ResourceTypes.getEventTypeByMainId(
            ResourceTypes.getEventTypes().find((type) => type.value == this.resource?.type_id)?.eventTypeId
        );
        this.subEventType = ResourceTypes.getEventTypeByTypeId(this.resource.type_id);
        this.cd.markForCheck();
    }
    public styleInnerHTML(description: string) {
        if (description) {
            return '<div class="inner-HTML-course">' + description + '</div>';
        } else {
            return;
        }
    }
    public checkCanJoiEvent() {
        return Utils.getResActionBtnWhenOppId(this.occasionDates).type !== 'not_available';
    }
    public getResourceAvailablity(resource: Resource): Observable<EventJoin> {
        return this.startEventService.checkEventJoin(resource).pipe(shareReplay());
    }
    joinEventDireclty() {
        this.startEventService.requestJoinEvent(this.resource, this.user).subscribe((res) => {
            this.checkCanJoiEvent();
            this.resource.opportunity_id = res.opportunity_id;
            this.cd.markForCheck();
        });
    }
    public takeEvent(resource: Resource, user: User, eventJoin: EventJoin) {
        this.startEventService.takeEvent(resource, user, eventJoin).subscribe((res) => {
            switch (eventJoin.status) {
                case 'Payment_needed':
                case 'allowed':
                    this.resource.purchased = res.purchased;
                    this.resource.available_seats = res.available_seats;
                    this.message.openMessage(
                        MessageSavedComponent,
                        $localize`Congratulations, you have registered successfully.`
                    );
                case 'approval_required':
                    this.resource.enrollment = res.enrollment;
            }
            this.checkCanJoiEvent();
            this.resource.opportunity_id = res.opportunity_id;
            this.cd.markForCheck();
        });
    }
}
